<template>
  <div>
    <v-btn icon small @click.stop="dialog = true"
      v-if="this.profileError || this.profileWarning">
      <div v-if="this.profileError">
        <v-icon :color="ui.colorError"> person </v-icon>
      </div>
        <div v-else>
        <v-icon :color="ui.colorWarning"> person </v-icon>
      </div>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogSmall">
      <v-card :class="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          User Profile Status
        </v-card-title>
        <v-card-text>
          <v-layout row :class="ui.textDescription">
            <v-flex xs4>
              <v-icon large :color="ui.colorWarning"> person </v-icon>
            </v-flex>
            <v-flex xs8>
              incomplete user profile,
              some functions may be disabled
            </v-flex>
          </v-layout>
          <v-divider/>
          <v-layout row :class="ui.textDescription">
            <v-flex xs4>
              <v-icon large :color="ui.colorError"> person </v-icon>
            </v-flex>
            <v-flex xs8>
             critical user data,
             user functionalityconstrained
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn :color="ui.btnColor" flat @click="dialog = false">
            <v-icon left> exit_to_app </v-icon>
            back
          </v-btn>        
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";

export default {
  data() {
    return {
      dialog: false
    };
  },
  mixins: [apptheme],
  computed: {
    ...mapGetters(["getUser"]),
    profileError() {
      let logic = false;
      if (
        // eslint-disable-next-line
        this.getUser.basic.lock === true ||
        this.getUser.basic.title === ""
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    profileWarning() {
      let logic = false;
      if (this.getUser.basic.phoneMob === "") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  }
};
</script>
